"use strict";
/*
 * Created on 07 05 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization API of {@link SelloutIdentificationOverview}.
 *
 * @author JMe
 */


var SelloutIdentificationOverviewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutIdentificationOverviewConverter, _DataObjectConverter_);

  function SelloutIdentificationOverviewConverter() {
    _classCallCheck(this, SelloutIdentificationOverviewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationOverviewConverter).apply(this, arguments));
  }

  return SelloutIdentificationOverviewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutIdentificationOverviewConverter = SelloutIdentificationOverviewConverter;